import { motion } from 'framer-motion';
import { ArrowLeft, Mail, MessageCircle, Server } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const contactMethods = [
  {
    icon: Mail,
    label: 'Email',
    value: 'Chingstocks1@gmail.com',
    href: 'mailto:Chingstocks1@gmail.com',
    testid: 'contact-email',
  },
  {
    icon: MessageCircle,
    label: 'Discord',
    value: 'quantumshopmain',
    href: null,
    testid: 'contact-discord',
  },
  {
    icon: Server,
    label: 'Discord Server',
    value: 'discord.gg/m3KARpebb',
    href: 'https://discord.gg/m3KARpebb',
    testid: 'contact-discord-server',
  },
];

const Contact = () => {
  return (
    <div className="min-h-screen bg-black text-white py-16 px-4" data-testid="contact-page">
      <div className="max-w-2xl mx-auto">
        <Link to="/">
          <Button
            variant="ghost"
            className="text-gray-400 hover:text-white mb-8"
            data-testid="contact-back-button"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 mb-3">
            Contact Us
          </h1>
          <p className="text-gray-400 mb-12">
            Reach out to Quantum Shop through any of the channels below.
          </p>

          <div className="space-y-5">
            {contactMethods.map((method, index) => {
              const Icon = method.icon;
              const content = (
                <div className="flex items-center gap-5 p-6 bg-gradient-to-br from-zinc-900 to-black border border-purple-900/30 rounded-2xl transition-all duration-300 group-hover:border-purple-500/50 group-hover:shadow-lg group-hover:shadow-purple-500/10">
                  <div className="w-14 h-14 rounded-xl bg-purple-500/15 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-6 h-6 text-purple-400" />
                  </div>
                  <div>
                    <div className="text-sm text-gray-400 uppercase tracking-wider mb-1">
                      {method.label}
                    </div>
                    <div className="text-lg font-bold text-white group-hover:text-purple-400 transition-colors break-all">
                      {method.value}
                    </div>
                  </div>
                </div>
              );

              return (
                <motion.div
                  key={method.label}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 * index }}
                  whileHover={{ y: -4 }}
                  className="group"
                  data-testid={method.testid}
                >
                  {method.href ? (
                    <a
                      href={method.href}
                      target={method.href.startsWith('http') ? '_blank' : undefined}
                      rel={method.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className="block"
                    >
                      {content}
                    </a>
                  ) : (
                    content
                  )}
                </motion.div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
